module.exports = __webpack_public_path__ + "img/buy-packages-screenshot.0f2a93bf.png";